const SizeChartModal = ({
  gender = "male",
  productType = "TShirt",
  sizeChartOpen,
  setSizeChartOpen,
}) => {
  const SIZE_CHARTS = {
    male_TShirt: {
      title: "Boy's T-Shirt",
      sizeLabel: "SIZE (YEARS)",
      rows: [
        { size: "0-1 yrs", chest: 20, length: 12.5 },
        { size: "1-2 yrs", chest: 22, length: 14 },
        { size: "2-3 yrs", chest: 24, length: 15.5 },
        { size: "3-4 yrs", chest: 26, length: 17 },
        { size: "4-6 yrs", chest: 28, length: 18.5 },
        { size: "6-8 yrs", chest: 30, length: 20 },
        { size: "8-10 yrs", chest: 32, length: 21.5 },
        { size: "10-12 yrs", chest: 34, length: 23 },
        { size: "12-14 yrs", chest: 36, length: 24.5 },
      ],
    },
    female_TShirt: {
      title: "Girl's T-Shirt",
      sizeLabel: "SIZE (YEARS)",
      rows: [
        { size: "0-1 yrs", chest: 18, length: 11.5 },
        { size: "1-2 yrs", chest: 20, length: 13 },
        { size: "2-3 yrs", chest: 22, length: 14.5 },
        { size: "3-4 yrs", chest: 24, length: 16 },
        { size: "4-6 yrs", chest: 26, length: 17.5 },
        { size: "6-8 yrs", chest: 28, length: 19 },
        { size: "8-10 yrs", chest: 30, length: 20.5 },
        { size: "10-12 yrs", chest: 32, length: 22 },
        { size: "12-14 yrs", chest: 34, length: 23.5 },
      ],
    },
    unisex_Romper: {
      title: "Kids Rompers",
      sizeLabel: "SIZE (MONTHS)",
      rows: [
        { size: "0-5 months", chest: 18, length: 16 },
        { size: "6-12 months", chest: 20, length: 18 },
      ],
    },
  };
  const getChartKey = (gender, productType) => {
    const key = `${gender}_${productType}`;

    console.log("Determining size chart for:", key);
    console.log("Determining size chart for:", SIZE_CHARTS[key].rows);

    return SIZE_CHARTS[key] ? key : "male_TShirt";
  };
  return (
    <div
      className={
        sizeChartOpen
          ? "modal fade modalDemo tf-product-modal popup-findsize show"
          : "modal fade modalDemo tf-product-modal popup-findsize hide"
      }
      id="find_size"
      style={{ zIndex: 1060, display: sizeChartOpen ? "block" : "none" }}
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="header">
            <div className="demo-title">Size chart</div>
            <span
              className="icon-close icon-close-popup"
              data-bs-dismiss="modal"
              onClick={() => setSizeChartOpen(false)}
            />
          </div>
          <div className="tf-rte">
            <div className="tf-table-res-df">
              <h6>
                {SIZE_CHARTS[`${gender}_${productType}`]?.title} Size guide
              </h6>
              <table className="tf-sizeguide-table">
                <thead>
                  <tr>
                    <th>Size</th>
                    <th>Chest</th>
                    <th>Length</th>
                  </tr>
                </thead>
                <tbody>
                  {(SIZE_CHARTS[`${gender}_${productType}`]?.rows || []).map(
                    (row, index) => {
                      return (
                        <tr key={index}>
                          <td>{row.size}</td>
                          <td>{row.chest}</td>
                          <td>{row.length}</td>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </table>
            </div>
            <div className="tf-page-size-chart-content">
              <div>
                <h6>Measuring Tips</h6>
                <div className="title">Chest</div>
                <p>Measure around the fullest part of your chest.</p>
                <div className="title">Length</div>
                <p>Measure around the narrowest part of your length.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SizeChartModal;
